import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { OpenModalType, initModalState } from './modalType'

const modalSlice = createSlice({
  name: 'modal',
  initialState: initModalState,
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalType>) => {
      state.isOpen = true
      state.data = action.payload
    },
    closeModal: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        const { cb } = action.payload
        cb && cb()
      }
      state.isOpen = false
      state.data = {}
    },
  },
  extraReducers: () => {},
})

export const modalCreateActions = modalSlice.actions
export default modalSlice
